import { render } from "./myEventList.vue?vue&type=template&id=84329620"
import script from "./myEventList.vue?vue&type=script&lang=js"
export * from "./myEventList.vue?vue&type=script&lang=js"

import "./myEventList.vue?vue&type=style&index=0&id=84329620&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__